exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collections-list {\n  width: 100%;\n}\n.collections-page {\n  width: 100%;\n  height: 92vh;\n  display: flex;\n  flex-direction: column;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/scenes/Collections/containers/Collections.less
// module id = 1230
// module chunks = 0